<template>
    <div class="appdetail">
      <!-- 标题、按钮 -->
      <div class="appdetail-title">
          <div class="appdetail-title-top clearfix">
              <div class="app-buttons">
                  <el-button icon="icon-save" class="btn-" type="primary" size="mini" @click="saveBtn('Update')">
                      <font>保存</font>
                  </el-button>

                  <el-button type="success" class="btn-" size="mini" @click="saveBtn('Submit')" v-show="addtitle"><font>保存并继续</font></el-button>
              </div>
          </div>
      </div>
      <el-tabs class="appdetail-content" type="border-card" v-model="currentDetailTabsModel" @tab-click="tabClick">
          <el-tab-pane label="列表" name="列表">
          </el-tab-pane>
          <el-tab-pane label="详情" name="详情">
            <div class="appdetail-content" :style="{height: 'calc(100vh - 205px)'}">
              <el-form :show-message="false" inline-message :model="adddeptForm" :rules="rules" ref="adddeptForm" label-width="100px" id="demo-adduserForm">
                  <div class="content-accordion">
                  <el-collapse v-model="activeNames">
                      <el-collapse-item title="机构信息" name="1">
                      <el-row :gutter="30">
                          <el-col :span="4" class="pull-right pb10">
                          <el-input :placeholder="edit?'':'请输入'" v-model="adddeptForm.version" :disabled="edit">
                              <template slot="prepend">版本</template>
                          </el-input>
                          </el-col>
                      </el-row>
                      <el-row :gutter="30">
                          <el-col :span="12">
                          <el-form-item label="机构编码" prop="code">
                              <el-input v-model="adddeptForm.code" placeholder="请输入"></el-input>
                          </el-form-item>
                          </el-col>
                          <el-col :span="12">
                          <el-form-item label="机构名称" prop="fullname">
                              <el-input placeholder="请输入" v-model="adddeptForm.fullname"></el-input>
                          </el-form-item>
                          </el-col>
                          <el-col :span="12">
                          <el-form-item label="上级机构" prop="parent">
                              <el-input placeholder="请选择" v-model="adddeptForm.parent" :disabled="edit">
                              <el-button slot="append" icon="el-icon-search" @click="getDept"></el-button>
                              </el-input>
                          </el-form-item>
                          </el-col>
                      </el-row>
                      <el-row :gutter="30">
                          <el-col :span="12">
                          <el-form-item label="机构类型" prop="depttype">
                              <el-select v-model="adddeptForm.depttype" placeholder="请选择" style="width: 100%">
                              <el-option v-for="(data,index) in Selectsys_depttype" :key="index" :value="data.code" :label="data.name"></el-option>
                              </el-select>
                          </el-form-item>
                          </el-col>
                          <el-col :span="12">
                          <el-form-item label="地址" prop="address">
                              <el-input placeholder="请输入" v-model="adddeptForm.address"></el-input>
                          </el-form-item>
                          </el-col>
                      </el-row>
                      <el-row :gutter="30">

                          <el-col :span="12">
                          <el-form-item label="邮政编码">
                              <el-input placeholder="请输入" v-model="adddeptForm.zipcode">
                              </el-input>
                          </el-form-item>
                          </el-col>
                          <el-col :span="12">
                          <el-form-item label="负责人">
                              <el-input placeholder="请选择" v-model="adddeptForm.leaderdesc" :disabled="edit">
                              <el-button slot="append" icon="el-icon-search" @click="getPerson"></el-button>
                              </el-input>
                          </el-form-item>
                          </el-col>
                          <el-col :span="12">
                          <el-form-item label="邮箱" prop="email">
                              <el-input placeholder="请输入" v-model="adddeptForm.email"></el-input>
                          </el-form-item>
                          </el-col>
                      </el-row>
                      <el-row :gutter="30">
                          <el-col :span="12">
                          <el-form-item label="电话" prop="telephone">
                              <el-input placeholder="请输入" v-model="adddeptForm.telephone"></el-input>
                          </el-form-item>
                          </el-col>
                          <el-col :span="12">
                          <el-form-item label="传真" prop="fax">
                              <el-input placeholder="请输入" v-model="adddeptForm.fax">
                              </el-input>
                          </el-form-item>
                          </el-col>
                      </el-row>
                      <el-row :gutter="30">
                          <el-col :span="12" v-if="adddeptForm.pid==128" v-show="true">
                          <el-form-item label="机构简称" prop="simplename" :rules="{required: true, message: '不能为空', trigger: 'blur'}">
                              <el-input placeholder="请输入" v-model="adddeptForm.simplename"></el-input>
                          </el-form-item>
                          </el-col>

                          <el-col :span="12" v-else v-show="false">
                          <el-form-item label="机构简称" prop="simplename">
                              <el-input placeholder="请输入" v-model="adddeptForm.simplename"></el-input>
                          </el-form-item>
                          </el-col>
                      </el-row>
                      <el-row :gutter="30">
                          <el-col :span="24">
                          <el-form-item label="备注" prop="tips">
                              <el-input rows="2" type="textarea" v-model="adddeptForm.tips" placeholder="请输入"></el-input>
                          </el-form-item>
                          </el-col>
                      </el-row>
                      </el-collapse-item>
                  </el-collapse>
                  </div>

              </el-form>
          </div>
          </el-tab-pane>
      </el-tabs>
      <!-- 弹出 -->
      <el-dialog :modal-append-to-body="false" title="上级机构" :visible.sync="dialogVisible" width="30%" :before-close="handleClose">
        <div class="scrollbar" style="height:400px;">
          <el-tree ref="tree" :data="resourceData" show-checkbox node-key="id" :default-checked-keys="resourceCheckedKey" :props="resourceProps" default-expand-all @node-click="handleNodeClick" @check-change="handleClicks" check-strictly>
          </el-tree>
        </div>
        <div slot="footer">
          <el-button type="primary" @click="queding();">确 定</el-button>
          <el-button @click="dialogVisible = false">取 消</el-button>
        </div>
      </el-dialog>

      <!--负责人 Begin-->
      <el-dialog :modal-append-to-body="false" title="选择负责人" :visible.sync="dialogLeader" width="80%" :before-close="handleClose">
        <!-- 第二层弹出的表格 -->
        <el-table :data="userList" border stripe height="420px" style="width: 100%;" :default-sort="{prop:'userList', order: 'descending'}" @selection-change="SelChange" v-loadmore="loadMore">
          <el-table-column type="selection" width="55" fixed>
          </el-table-column>
          <el-table-column label="账号" sortable width="140px" prop="username">
          </el-table-column>
          <el-table-column label="姓名" sortable width="200px" prop="nickname">
          </el-table-column>
          <el-table-column label="机构" sortable width="150px" prop="deptName">
          </el-table-column>
          <el-table-column label="公司" sortable prop="companyName">
          </el-table-column>
          <el-table-column label="录入时间" width="150px" prop="createTime" sortable :formatter="dateFormat">
          </el-table-column>
        </el-table>
        <el-pagination background class="text-right pt10" @size-change="sizeChange" @current-change="currentChange" :current-page="page.currentPage" :page-sizes="[10, 20, 30, 40]" :page-size="page.pageSize" layout="total, sizes, prev, pager, next" :total="page.totalCount">
        </el-pagination>
        <!-- 表格 -->

        <div slot="footer">
          <el-button type="primary" @click="addleader">确 定</el-button>
          <el-button @click="dialogLeader = false">取 消</el-button>
        </div>
      </el-dialog>
      <!--负责人 End-->
    </div>
</template>

<script>

export default {
  name: 'dept_managementdetail',
  data() {
    return {
      currentDetailTabsModel:"详情",
        adddeptForm:{},
      basic_url: Config.dev_url,
      drawer:false,
      value: '',
      loading: false, //加载
      commentArr: {},
      options: [{
        value: '1',
        label: '活动'
      }, {
        value: '2',
        label: '不活动'
      }],
      stopoptions: [{
        value: '1',
        label: '是'
      }, {
        value: '2',
        label: '否'
      }],
      selUser: [],
      selData: [],//获取当前负责人
      SelectDEPT_TYPE: [],//获取机构属性
      Selectsys_depttype: [],//获取机构类型
      activeNames: ['1'], //手风琴数量
      userList: [],
      page: {
        currentPage: 1,
        pageSize: 20,
        totalCount: 0
      },
      dialogVisible: false, //对话框
      edit: true, //禁填
      editSearch: '',
      fullHeight: document.documentElement.clientHeight - 210 + 'px',//获取浏览器高度
      show: false,
      addtitle: true,//添加弹出框titile
      dialogLeader: false,
      stopcontent: false,
      stopselect: false,
      //tree树菜单
      resourceData: [], //数组，我这里是通过接口获取数据
      resourceDialogisShow: false,
      resourceCheckedKey: [], //通过接口获取的需要默认展示的数组 [1,3,15,18,...]
      resourceProps: {
        children: "children",
        label: "fullname"
      },
      rules: {
        step: [{ required: false, trigger: 'blur', validator: this.Validators.isWorknumber }],//机构序号
        fullname: [
          { required: true, trigger: 'blur', message: '必填', validator: this.Validators.isNickname }
        ],//机构名称
        code: [{ required: true, trigger: 'blur', message: '必填' }],//机构属性
        zipcode: [{ required: false, trigger: 'blur', message: '请输入邮编' }],//选择机构类型
        tips: [{ required: false, trigger: 'blur', validator: this.Validators.isSpecificKey }],//备注
        leaderdesc: [{ required: true, trigger: 'blur', message: '请输入负责人' }],
      }
    }
  },
  methods: {
    //获取创建人描述
    getcreateuserdesc() {
        if (!!this.adddeptForm.createuser) {
            var url = Config.dev_url + '/api-user/users/' + this.adddeptForm.createuser
            this.$axios.get(url).then((res) => {
                this.$set(this.adddeptForm, 'createuserdesc', res.data.nickname)
            }).catch((err) => {
                });
        }
    },
    //获取修改人描述
    getupdateuserdesc() {
        if (!!this.adddeptForm.updateuser) {
            var url = Config.dev_url + '/api-user/users/' + this.adddeptForm.updateuser
            this.$axios.get(url).then((res) => {
                this.$set(this.adddeptForm, 'updateuserdesc', res.data.nickname)
            }).catch((err) => {
                });
        }
    },
    handleNodeClick(data) { //获取勾选树菜单节点

    },
    handleClicks(data, checked, indeterminate) {
      this.getCheckboxData = data;
      this.i++;
      if (this.i % 2 == 0) {
        if (checked) {
          this.$refs.tree.setCheckedNodes([]);
          this.$refs.tree.setCheckedNodes([data]);
          //交叉点击节点
        } else {
          this.$refs.tree.setCheckedNodes([]);
          //点击已经选中的节点，置空
        }
      }
    },
    addBtn(){
        this.adddeptForm = {
          version: '1',
          status: '',
          step: '',
          code: '',
          fullname: '',
          parent: '',
          pcode: '',
          depttype: '2',
          type: '',
          inactive: '',
          address: '',
          zipcode: '',
          leader: '',
          leaderdesc: '',
          telephone: '',
          fax: '',
          email: '',
          simplename: '',
          tips: '',
          createuserdesc: '',
          createtime: '',
          updateuserdesc: '',
          updatetime: '',
        };
        this.addtitle = true;
        this.currentDetailTabsModel = "详情"
    },

    //这是查看
    view(item) {
        console.log(item)
        this.currentDetailTabsModel = "详情"
        this.adddeptForm = item
        this.getupdateuserdesc()
        this.getcreateuserdesc()
        this.addtitle = false;
    },
    //获取负责人数据
    getPerson() {
      this.requestData();
      this.dialogLeader = true;
    },
    SelChange(val) {
      this.selUser = val;
    },
    loadMore() {
      if (this.loadSign) {
        this.loadSign = false
        this.page.currentPage++
        if (this.page.currentPage > Math.ceil(this.page.totalCount / this.page.pageSize)) {
          return
        }
        setTimeout(() => {
          this.loadSign = true
        }, 1000)
        this.requestData()
      }
    },
    sizeChange(val) {
      this.page.pageSize = val;
      this.requestData();
    },
    currentChange(val) {
      this.page.currentPage = val;
      this.requestData();
    },
    judge(data) {
      //taxStatus 布尔值
      return data.enabled ? '活动' : '不活动'
    },
    //时间格式化
    dateFormat(row, column) {
      var date = row[column.property];
      if (date == undefined) {
        return "";
      }
      return this.$moment(date).format("YYYY-MM-DD");
    },
    addleader() {
      var selData = this.selUser;
      if (selData.length == 0) {
        this.$message({
          message: '请您选择数据',
          type: 'warning'
        });
        return;
      } else if (selData.length > 1) {
        this.$message({
          message: '不可同时选择多条数据',
          type: 'warning'
        });
        return;
      } else {
        this.adddeptForm.leader = selData[0].id;
        this.adddeptForm.leaderdesc = selData[0].nickname;
        this.dialogLeader = false;
      }
    },

    //所属上级
    getDept() {
      var page = this.page.currentPage;
      var limit = this.page.pageSize;
      var url = Config.dev_url + '/api-user/depts/treeMap';
      this.$axios.get(url, {
      }).then((res) => {
        this.resourceData = res.data;
        this.dialogVisible = true;
      }).catch((err) => {
                });
    },
    queding() {
      this.getCheckedNodes(this.checkedNodes);
      if (this.checkedNodes == undefined) {
        this.$message({
          message: '请选择数据',
          type: 'warning'
        })

      } else {
        console.log(this.checkedNodes)
        this.dialogVisible = false;
        //  code 关联
        this.adddeptForm.pcode = this.checkedNodes[0].code
        this.adddeptForm.parent = this.checkedNodes[0].fullname;
      }
    },
    getCheckedNodes() {
      this.checkedNodes = this.$refs.tree.getCheckedNodes()
    },

    //生成随机数函数
    rand(min, max) {
      return Math.floor(Math.random() * (max - min)) + min;
    },
    getDEPT_TYPE() {//获取机构属性
      var url = Config.dev_url + '/api-user/dicts/findChildsByCode?code=DEPT_TYPE';
      this.$axios.get(url, {}).then((res) => {
        this.SelectDEPT_TYPE = res.data;
      }).catch(error => {
      })
    },
    getsys_depttype() {//获取机构类型
      var url = Config.dev_url + '/api-user/dicts/findChildsByCode?code=dept_type';
      this.$axios.get(url, {}).then((res) => {
        this.Selectsys_depttype = res.data;
      }).catch(error => {
      })
    },
    //获取负责人数据
    requestData() {
      var data = {
        page: this.page.currentPage,
        limit: this.page.pageSize,
        companyId: this.companyId,
        deptcode: this.deptcode
      }
      var url = Config.dev_url + '/api-user/users';
      this.$axios.get(url, {
        params: data
      }).then((res) => {
        this.page.totalCount = res.data.count;
        //总的页数
        let totalPage = Math.ceil(this.page.totalCount / this.page.pageSize)
        if (this.page.currentPage >= totalPage) {
          this.loadSign = false
        } else {
          this.loadSign = true
        }
        this.commentArr[this.page.currentPage] = res.data.data
        let newarr = []
        for (var i = 1; i <= totalPage; i++) {

          if (typeof (this.commentArr[i]) != 'undefined' && this.commentArr[i].length > 0) {

            for (var j = 0; j < this.commentArr[i].length; j++) {
              newarr.push(this.commentArr[i][j])
            }
          }
        }

        this.userList = newarr;
      }).catch((wrong) => { })
    },
    //保存
    saveBtn(parameter) {
      var _this = this;
      this.$refs.adddeptForm.validate((valid) => {
        if (valid) {
          _this.adddeptForm.status = ((_this.adddeptForm.status == "1" || _this.adddeptForm.status == '活动') ? '1' : '0');
          var url = Config.dev_url + '/api-user/depts/saveOrUpdate';
          this.$axios.post(url, {
            address: this.adddeptForm.address,
            children: this.adddeptForm.children,
            code: this.adddeptForm.code,
            createtime: this.adddeptForm.createtime,
            createuser: this.adddeptForm.createuser,
            createuserdesc: this.adddeptForm.createuserdesc,
            del_flag: this.adddeptForm.del_flag,
            depttype: this.adddeptForm.depttype,
            depttypedesc: this.adddeptForm.depttypedesc,
            email: this.adddeptForm.email,
            simplename: this.adddeptForm.simplename,
            fullname: this.adddeptForm.fullname,
            id: this.adddeptForm.id,
            leaderdesc: this.adddeptForm.leaderdesc,
            leader: this.adddeptForm.leader,
            fax: this.adddeptForm.fax,
            tips: this.adddeptForm.tips,
            pcode: this.adddeptForm.pcode,
            parent: this.adddeptForm.parent,
            status: this.adddeptForm.status,
            telephone: this.adddeptForm.telephone,
            type: this.adddeptForm.type,
            typedesc: this.adddeptForm.typedesc,
            updatetime: this.adddeptForm.updatetime,
            updateuser: this.adddeptForm.updateuser,
            updateuserdesc: this.adddeptForm.updateuserdesc,
          }).then((res) => {
            //resp_code == 0是后台返回的请求成功的信息
            if (res.data.code == 0) {
              this.$message({
                message: '保存成功',
                type: 'success'
              });
              if (parameter == "Submit") {
                this.adddeptForm = {
                  version: '1',
                  status: '',
                  step: '',
                  code: '',
                  fullname: '',
                  parent: '',
                  pcode: '',
                  depttype: '2',
                  type: '',
                  inactive: '',
                  address: '',
                  zipcode: '',
                  leader: '',
                  leaderdesc: '',
                  telephone: '',
                  fax: '',
                  email: '',
                  simplename: '',
                  tips: '',
                  createuserdesc: '',
                  createtime: '',
                  updateuserdesc: '',
                  updatetime: '',
                };
              }
              this.addtitle = true;
            }
          }).catch((err) => {
            this.$message({
              message: err.msg,
              type: 'warning'
            });
          });
        } else {
          this.$message({
            message: '未填写完整，请填写',
            type: 'warning'
          });
        }
      });

    },
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          done();
        })
        .catch(_ => {
          console.log('取消关闭');
          $('.v-modal').hide();
        });
    },
    clearInput(data, chooseParam) {
            for (var i = 0; i < chooseParam.tableHeader.length; i++) {
                if(!!chooseParam.tableHeader[i].targetAttribute && !!this.adddeptForm[chooseParam.tableHeader[i].targetAttribute]){
                    this.adddeptForm[chooseParam.tableHeader[i].targetAttribute] = ""
                }
            }
        },
        choose(target, chooseParam) {
            for (var i = 0; i < chooseParam.tableHeader.length; i++) {
                chooseParam.tableHeader[i].targetObject = target;
            }
            this.chooseParam = chooseParam;
            this.$refs.vchoose.getListData("new", this.chooseParam);
        },
        updateChoose(data) {
            this.$forceUpdate();
        },
        //tab选项卡点击
        tabClick(tab){
            if(tab.label == "列表"){
                this.$store.commit('setcurrentShowPage',1)
                this.$emit("requestData")
            }else{
                this.$store.commit('setcurrentShowPage',2)
            }
        },
  },
  mounted() {
    // this.getDEPT_TYPE();//页面打开加载-机构属性
    this.getsys_depttype();//页面打开加载-机构类型
    this.requestData();
  },
  computed:{
        //当前左侧菜单选中的信息
        currentSelectMenuData(){
            return this.$store.state.currentSelectMenuData
        },
        //当前登录人信息
        currentuser() {
            return this.$store.state.currentuser
        },
    },
}
</script>

<style>

</style>
